import 'vuetify/styles'
import '@mdi/font/css/materialdesignicons.css'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { de } from 'vuetify/locale'

export const vuetify = createVuetify({
  components,
  directives,

  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        dark: false,
        colors: {
          primary: '#003463',
          secondary: '#618197',
          accent: '#0099dc',

          navigation: '#003463',
          background: '#f6f8fa',
          surface: '#ffffff',
          'surface-bright': '#ffffff',
          'surface-light': '#f8fafc',
          'surface-variant': '#e8ebee',

          tertiary: '#d8dfe3',
          quaternary: '#e8ebee',

          error: '#b00020',
          success: '#2e7d32',
          warning: '#ed6c02',
          info: '#0288d1',

          'on-primary': '#ffffff',
          'on-secondary': '#ffffff',
          'on-background': '#102033',
          'on-surface': '#102033',

          // Muss mitgesetzt werden, sobald `surface-variant` gesetzt ist.
          // Vuetify liefert die beiden als Paar aus und erzeugt `on-*` nur
          // dann selbst, wenn es nicht schon dasteht — hier stand es. Die
          // Vorgabe geht von einem *invertierten* `surface-variant` aus
          // (hell: dunkle Flaeche `#424242` mit heller Schrift `#EEEEEE`).
          // Diese Anwendung hat die Flaeche auf ein helles `#e8ebee` gedreht,
          // die Schrift blieb `#EEEEEE` — Kontrast 1,03:1, also praktisch
          // unsichtbar. Getroffen hat es vor allem die Kurzhinweise: die
          // Vorgabe von `v-tooltip` faerbt sich genau aus diesem Paar.
          'on-surface-variant': '#102033',
        },
      },

      dark: {
        dark: true,
        colors: {
          primary: '#3f5f8f',
          secondary: '#7f91ad',
          accent: '#8175ad',

          navigation: '#003463',
          background: '#10141c',
          surface: '#181e29',
          'surface-bright': '#252d3b',
          'surface-light': '#1e2532',
          'surface-variant': '#293243',

          tertiary: '#39465b',
          quaternary: '#222a37',

          error: '#ffb4ab',
          success: '#91c9a4',
          warning: '#dfb36d',
          info: '#769fbd',

          'on-primary': '#ffffff',
          'on-secondary': '#ffffff',
          'on-background': '#e8edf5',
          'on-surface': '#e8edf5',

          // Dasselbe umgekehrt: Vuetifys dunkle Vorgabe erwartet eine helle
          // Flaeche (`#c8c8c8`) und setzt die Schrift deshalb auf `#000000`.
          // Hier ist die Flaeche `#293243` — Kontrast 1,63:1.
          'on-surface-variant': '#e8edf5',
        },
      },
      // dark: {
      //   dark: true,
      //   colors: {
      //     primary: '#2f6688',
      //     secondary: '#8ba8bb',
      //     accent: '#53c7ff',

      //     background: '#0f1720',
      //     surface: '#17212b',
      //     'surface-bright': '#22303d',
      //     'surface-light': '#1d2a36',
      //     'surface-variant': '#263545',

      //     tertiary: '#324657',
      //     quaternary: '#22303d',

      //     error: '#ffb4ab',
      //     success: '#9bd89f',
      //     warning: '#ffd29d',
      //     info: '#9ad7ff',

      //     'on-primary': '#ffffff',
      //     'on-secondary': '#ffffff',
      //     'on-background': '#e8eef5',
      //     'on-surface': '#e8eef5',
      //   },
      // },
    },
  },

  locale: {
    locale: 'de',
    messages: { de },
  },

  icons: {
    defaultSet: 'mdi',
  },
})